import { Injectable, Input } from '@angular/core';
import { GuidedTour, GuidedTourService } from 'ngx-guided-tour';
import { MarkdownEditorService } from '../pages/markdown-editor/markdown-editor.service';
import { GithubService } from './github.service';
import { Node } from '../models/node.model';

@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  callBack = () => {

  };
  markdownInstance: MarkdownEditorService;

  constructor(private tourService: GuidedTourService, private githubService: GithubService) {
    this.markdownInstance = MarkdownEditorService.getInstance(githubService);
  }

  setTour(tour: GuidedTour) {
    if (localStorage.getItem(tour.tourId)) {
      this.callBack();
      return;
    }
    tour.skipCallback = tour.completeCallback = () => {
      this.callBack();
      localStorage.setItem(tour.tourId, 'true');
    };
    this.tourService.startTour(tour);
    const node = new Node();
    node.path = 'Example.md';
    node.content = '# Example\n\nThis is an example markdown file';
    this.markdownInstance.openFile(node);
    return this.tourService;
  }
}
